import {
    CREATE_IRONING_PACKING_DC_DETAILS_FAILURE,
    CREATE_IRONING_PACKING_DC_DETAILS_REQUEST,
    CREATE_IRONING_PACKING_DC_DETAILS_SUCCESS,
    CREATE_USER_FORM_IRONING_PACKING_DC_DETAILS,
    DELETE_IRONING_PACKING_DC_DETAILS_FAILURE,
    DELETE_IRONING_PACKING_DC_DETAILS_REQUEST,
    DELETE_IRONING_PACKING_DC_DETAILS_SUCCESS,
    FETCH_SINGLE_IRONING_PACKING_DC_DETAILS_FAILURE,
    FETCH_SINGLE_IRONING_PACKING_DC_DETAILS_REQUEST,
    FETCH_SINGLE_IRONING_PACKING_DC_DETAILS_SUCCESS,
    FETCH_IRONING_PACKING_DC_DETAILS_FAILURE,
    FETCH_IRONING_PACKING_DC_DETAILS_REQUEST,
    FETCH_IRONING_PACKING_DC_DETAILS_SUCCESS,
    IRONING_PACKING_DC_DETAILS_USERFORM_RESET,
    UPDATE_IRONING_PACKING_DC_DETAILS_FAILURE,
    UPDATE_IRONING_PACKING_DC_DETAILS_REQUEST,
    UPDATE_IRONING_PACKING_DC_DETAILS_SUCCESS,
    FETCH_IRONING_PACKING_DC_DETAILS_BY_ID_REQUEST,
    FETCH_IRONING_PACKING_DC_DETAILS_BY_ID_SUCCESS,
    FETCH_IRONING_PACKING_DC_DETAILS_DC_NO_REQUEST,
    FETCH_IRONING_PACKING_DC_DETAILS_DC_NO_SUCCESS,
    FETCH_IRONING_PACKING_DC_DETAILS_DC_NO_FAILURE,
    FETCH_GRN_NO_BY_IRONING_PACKING_DC_NO_REQUEST,
    FETCH_GRN_NO_BY_IRONING_PACKING_DC_NO_SUCCESS,
    FETCH_GRN_NO_BY_IRONING_PACKING_DC_NO_FAILURE,
    FETCH_IRONING_PACKING_DC_DETAILS_PROGRAM_REQUEST,
    FETCH_IRONING_PACKING_DC_DETAILS_PROGRAM_SUCCESS,
    FETCH_IRONING_PACKING_DC_DETAILS_PROGRAM_FAILURE,
    FETCH_IRONING_PACKING_DC_DETAIL_EDIT_QUANTITY_SUCCESS,
    FETCH_IRONING_PACKING_DC_DETAIL_EDIT_QUANTITY_REQUEST,
    FETCH_IRONING_PACKING_DC_DETAIL_EDIT_QUANTITY_FAILURE,
    CREATE_IRONING_PACKING_DC_DETAIL_EDIT_QTY_MASTER_REQUEST,
    CREATE_IRONING_PACKING_DC_DETAIL_EDIT_QTY_MASTER_SUCCESS,
    CREATE_IRONING_PACKING_DC_DETAIL_EDIT_QTY_MASTER_FAILURE,
    CREATE_USER_FORM_IRONING_PACKING_DC_EDIT_QTY,
    RESET_IRONING_PACKING_DC_EDIT_QTY,
    FETCH_IRONING_PACKING_DC_PREVIOUS_GET_LIST_DETAILS_REQUEST,
    FETCH_IRONING_PACKING_DC_PREVIOUS_GET_LIST_DETAILS_SUCCESS,
    FETCH_IRONING_PACKING_DC_DETAILS_SECOND_GRID_REQUEST,
    FETCH_IRONING_PACKING_DC_DETAILS_SECOND_GRID_SUCCESS,
    FETCH_IRONING_PACKING_DC_PREVIOUS_GET_LIST_DETAILS_FAILURE,
    FETCH_IRONING_PACKING_DC_DETAILS_SECOND_GRID_FAILURE,
    IRONING_PACKING_DC_PROGRAM_ID_SUCCESS,
    IRONING_PACKING_DC_PROGRAM_ID_REQUEST,
    IRONING_PACKING_DC_PROGRAM_ID_FAILURE,
    IRONING_DC_WITH_ACC_REQUEST,
    IRONING_DC_WITH_ACC_SUCCESS,
    IRONING_DC_WITH_ACC_FAILURE,
    CREATE_USER_FORM_IRONING_WITH_ACC_GENERATE_QTY,
    CREATE_IRONING_DC_WITH_ACC_REQUEST,
    IRONING_AND_PACKINGD_C_WITH_ACC_SUCCESS,
    IRONING_AND_PACKING_DC_WITH_ACC_SUCCESS,
    RESET_TO_IRONING_ACC_PERVIOUS_LIST,
    DELETE_IRONING_PACKING_DC_ACC_REQUEST,
    DELETE_IRONING_PACKING_DC_ACC_FAILURE
} from './IroningPackingDCDetails.actionsType';

export const IRONING_PACKING_DC_DETAILS = 'ironingPackingDcDetails';

let initialState = {
    loading: false,
    ironingPackingDCDetailsById: [],
    ironingPackingDCDetails: [],
    ironingPackingDCDetailsDcNo: [],
    grnNoByIroningPackingDcNo: [],
    editIroningPackingQtyList: [],
    ironingPackingDCDetailsProgram: [],
    userform: {
        fldRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0
    },
    previousList: [],
    IroningPacking2ndGridData: [],
    ironingAndPackingAccessoriesGridData: [],
    selectedIroningPackingDC2Details: {},
    errorMessage: '',
    iperrorMessage: '',

};

export let ironingPackingDCDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_IRONING_PACKING_DC_DETAILS_REQUEST:
        case FETCH_IRONING_PACKING_DC_DETAIL_EDIT_QUANTITY_REQUEST:
        case FETCH_IRONING_PACKING_DC_DETAILS_PROGRAM_REQUEST:
        case FETCH_GRN_NO_BY_IRONING_PACKING_DC_NO_REQUEST:
        case FETCH_IRONING_PACKING_DC_DETAILS_DC_NO_REQUEST:
        case FETCH_IRONING_PACKING_DC_DETAILS_BY_ID_REQUEST:
        case CREATE_IRONING_PACKING_DC_DETAILS_REQUEST:
        case CREATE_IRONING_PACKING_DC_DETAIL_EDIT_QTY_MASTER_REQUEST:
        case FETCH_SINGLE_IRONING_PACKING_DC_DETAILS_REQUEST:
        case UPDATE_IRONING_PACKING_DC_DETAILS_REQUEST:
        case DELETE_IRONING_PACKING_DC_DETAILS_REQUEST:
        case FETCH_IRONING_PACKING_DC_PREVIOUS_GET_LIST_DETAILS_REQUEST:
        case FETCH_IRONING_PACKING_DC_DETAILS_SECOND_GRID_REQUEST:
        case IRONING_DC_WITH_ACC_REQUEST:
        case CREATE_IRONING_DC_WITH_ACC_REQUEST:
        case DELETE_IRONING_PACKING_DC_ACC_REQUEST:
            return {
                ...state,
                loading: true
            };
        case IRONING_PACKING_DC_PROGRAM_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                fldFkProgramId: updatePayload.fldFKProgram
            }
        case IRONING_PACKING_DC_PROGRAM_ID_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case IRONING_PACKING_DC_PROGRAM_ID_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_IRONING_PACKING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                ironingPackingDCDetails: updatePayload
            };
        case FETCH_IRONING_PACKING_DC_PREVIOUS_GET_LIST_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                previousList: updatePayload?.Program
            };
        case FETCH_IRONING_PACKING_DC_DETAILS_SECOND_GRID_SUCCESS:
            return {
                ...state,
                loading: false,
                // editIroningPackingQtyList: updatePayload.STD,
                FldDCQty: updatePayload.STD.map((x) => x.PendingQty),
                // balanceQty: updatePayload.STD.map((x) => x.PendingQty),
                loadRefresh: updatePayload.STD.map((x) => x),
                editIroningPackingQtyList: (updatePayload?.STD && updatePayload?.STD.map((x) => ({ ...x, balanceQty: x?.PendingQty, FldDCQty: x?.PendingQty }))) || []
            };
        case FETCH_IRONING_PACKING_DC_DETAIL_EDIT_QUANTITY_SUCCESS:
            return {
                ...state,
                loading: false,
                editIroningPackingQtyList: updatePayload,
                FldDCQty: updatePayload.STD.map((x) => x.PendingQty),
                loadRefresh: updatePayload.STD.map((x) => x)
            };
        case FETCH_IRONING_PACKING_DC_DETAILS_PROGRAM_SUCCESS:
            return {
                ...state,
                loading: false,
                ironingPackingDCDetailsProgram: updatePayload?.Program
            };
        case FETCH_IRONING_PACKING_DC_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                ironingPackingDCDetailsById: updatePayload
            };
        case FETCH_GRN_NO_BY_IRONING_PACKING_DC_NO_SUCCESS:
            return {
                ...state,
                loading: false,
                grnNoByIroningPackingDcNo: updatePayload?.Inward
            };
        case CREATE_IRONING_PACKING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                editIroningPackingQtyList: updatePayload?.IPD
            };
        case RESET_IRONING_PACKING_DC_EDIT_QTY:
            return {
                ...state,
                loading: false,
                editIroningPackingQtyList: []
            };
        case CREATE_IRONING_PACKING_DC_DETAIL_EDIT_QTY_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                editPrintingQtyList: [],
                userform: {
                    ...state.userform,
                    InwardNO: []
                },

            };
        case FETCH_IRONING_PACKING_DC_DETAILS_DC_NO_SUCCESS:
            return {
                ...state,
                loading: false,
                ironingPackingDCDetailsDcNo: updatePayload?.IPD
            };
        case FETCH_SINGLE_IRONING_PACKING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedIroningPackingDC2Details: updatePayload[0],
                userform: updatePayload[0]
            };
        case UPDATE_IRONING_PACKING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedIroningPackingDC2Details: {},
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case DELETE_IRONING_PACKING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                selectedIroningPackingDC2Details: {}
            };
        case IRONING_DC_WITH_ACC_SUCCESS:
            return {
                ...state,
                loading: false,
                ironPkgaccgetList: updatePayload

            };

        case IRONING_AND_PACKING_DC_WITH_ACC_SUCCESS:
            return {
                ...state,
                loading: false,
                ironingAndPackingAccessoriesGridData: updatePayload

            };
        case CREATE_USER_FORM_IRONING_WITH_ACC_GENERATE_QTY:
            return {
                ...state,
                loading: false,
                editIronAccQtyList: payload
                // editAccQtyList: payload?.map((x) => ({ ...x, CurrentIssue: x.availableQty }))
            };
        case RESET_TO_IRONING_ACC_PERVIOUS_LIST:
            return {
                ...state,
                loading: false,
                editIronAccQtyList: []
            }
        case FETCH_IRONING_PACKING_DC_DETAILS_FAILURE:
        case FETCH_IRONING_PACKING_DC_DETAIL_EDIT_QUANTITY_FAILURE:
        case FETCH_IRONING_PACKING_DC_DETAILS_PROGRAM_FAILURE:
        case FETCH_IRONING_PACKING_DC_DETAILS_DC_NO_FAILURE:
        case FETCH_GRN_NO_BY_IRONING_PACKING_DC_NO_FAILURE:
        case FETCH_SINGLE_IRONING_PACKING_DC_DETAILS_FAILURE:
        case CREATE_IRONING_PACKING_DC_DETAILS_FAILURE:
        case CREATE_IRONING_PACKING_DC_DETAIL_EDIT_QTY_MASTER_FAILURE:
        case UPDATE_IRONING_PACKING_DC_DETAILS_FAILURE:
        case DELETE_IRONING_PACKING_DC_DETAILS_FAILURE:
        case FETCH_IRONING_PACKING_DC_PREVIOUS_GET_LIST_DETAILS_FAILURE:
        case FETCH_IRONING_PACKING_DC_DETAILS_SECOND_GRID_FAILURE:
        case IRONING_DC_WITH_ACC_FAILURE:
        case DELETE_IRONING_PACKING_DC_ACC_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_IRONING_PACKING_DC_DETAILS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case CREATE_USER_FORM_IRONING_PACKING_DC_EDIT_QTY:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform
                },
                editIroningPackingQtyList: payload
            };
        case IRONING_PACKING_DC_DETAILS_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                selectedIroningPackingDC2Details: {}
            };
        default:
            return state;
    }
};
